import { Inject, Injectable, InjectionToken } from '@angular/core';
import { AuthService } from '@services/auth.service';

const userKey = (key: string, userId: string) => `user_${userId}_${key}`;

export const LOCAL_STORAGE = new InjectionToken<Storage>('Local Storage', {
  factory: () => localStorage,
});

@Injectable({
  providedIn: 'root',
})
export class UserStorageService {
  constructor(@Inject(LOCAL_STORAGE) private readonly storage: Storage, private readonly authService: AuthService) {}

  get userId(): string {
    return this.authService.authTokenData$.value?.sub;
  }

  clear(): void {
    this.storage.clear();
  }

  getItem(key: string, asObj: boolean): any {
    let item = this.storage.getItem(userKey(key, this.userId));
    if (item && asObj) {
      item = JSON.parse(item);
    }
    return item;
  }

  removeItem(key: string): void {
    this.storage.removeItem(userKey(key, this.userId));
  }

  setItem(key: string, value: string | Record<any, any>): void {
    this.storage.setItem(userKey(key, this.userId), typeof value === 'string' ? value : JSON.stringify(value));
  }
}
